/* eslint-disable react/prop-types */
import React, { useRef } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
import { resetTrendValue } from "../../helpers/fidaToOldConverter.ts";
import kpisTitle from "../../helpers/overview.ts";
import { useSelector } from "react-redux";
const LineChart = () => {
  const { graphObj } = useSelector((state) => state.overview);
  const { filter} = useSelector((state) => state.filter);
  const { selectedStart, selectedEnd } = filter;
  const { key, graph: graphD } = graphObj;
  const keyOf = key;
  const graph = graphD;
  const chartRef = useRef(null);
  const yKey = kpisTitle[key] || '';

  const options = {
    chart: {
      id: `${yKey}-${selectedStart}-${selectedEnd}`,
      type: "line",
      zoom: {
        enabled: true,
        type: 'xy'
      },
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
        export: {
          csv: {
            filename: `${yKey}_${selectedStart}_${selectedEnd}`,
            headerCategory: 'Date'
          },
          svg: {
            filename: `${yKey}_${selectedStart}_${selectedEnd}`,
          },
          png: {
            filename: `${yKey}_${selectedStart}_${selectedEnd}`,
          },
        },
      },
      // animations: {
      //   enabled: true,
      //   easing: 'easeinout',
      //   speed: 800,
      // }
    },
    stroke: {
      width: [3, 3, 3],
      curve: "straight",
      dashArray: [0, 5, 5],
    },
    xaxis: {
      tickAmount: 50,
      labels: {
        show: true,
      },
    },
    yaxis: {
      
      labels: {
        show: true,
      },
      title: {
        text: yKey
      }
    },
    legend: {
      show: true,
      position:'top'
    },
    grid: {
      show: false,
    },
    markers: {
      size: 4,
    },
    tooltip: {
      // eslint-disable-next-line no-unused-vars
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        if (
          w.config.series[0].data &&
          w.config.series[1].data &&
          w.config.series[0].data[dataPointIndex] !== undefined &&
          w.config.series[1].data[dataPointIndex] !== undefined
        ) {
          const selectedValue = w.config.series[0].data[dataPointIndex];
          const comparedValue = w.config.series[1].data[dataPointIndex];
          // selected
          const sValue = selectedValue?.formattedValue;
          const cValue = comparedValue?.formattedValue;
          return (
            '<div class="custom-tooltip">' +
            "<div>" +
            selectedValue.time +
            "<div>" +
            '<div class="selected"><span class="graphDotB">●</span>Selected: ' +
            sValue +
            "</div>" +
            "<div class='compare-div'>" +
            comparedValue.time +
            "<div>" +
            '<div class="selected"><span class="graphDotG">●</span>Compared: ' +
            cValue +
            "</div>" +
            "</div>"
          );
        } else {
          return "";
        }
      },
    },
  };

  const graphData = graph?.data
    ? JSON.parse(JSON.stringify(graph?.data))
    : null;
  if (graphData) {
    resetTrendValue(graphData, keyOf);
  }
  const selectedPeriod = graphData?.selectedPeriod;
  const comparedPeriod = graphData?.comparedPeriod;
  //
  const selected = selectedPeriod?.map((item) => ({
    x:
      item["timeLabel"].length == 2
        ? item["timeLabel"] + ":00"
        : moment(item["timeLabel"]).format("MMM DD"),
    y: item[keyOf],
    formattedValue: item.formattedValue,
    time:
      item["timeLabel"].length == 2
        ? item["timeLabel"] + ":00"
        : `${moment(item["timeLabel"]).format("ll")}(${moment(
            item["timeLabel"]
          ).format("ddd")})`,
  }));
  const compared = comparedPeriod?.map((item) => ({
    x:
      item["timeLabel"].length == 2
        ? item["timeLabel"] + ":00"
        : moment(item["timeLabel"]).format("MMM DD"),
    y: item[keyOf],
    formattedValue: item.formattedValue,
    time:
      item["timeLabel"].length == 2
        ? item["timeLabel"] + ":00"
        : `${moment(item["timeLabel"]).format("ll")}(${moment(
            item["timeLabel"]
          ).format("ddd")})`,
  }));
  const series = [];

  series[0] = {
    name: "Selected Period",
    data: selected || [],
  };
  series[1] = {
    name: "Compared Period",
    data: compared || [],
  };
  return (
    <div>
      <Chart
        ref={chartRef}
        options={options}
        series={series}
        type="line"
        height="300px"
      />
    </div>
  );
};

export default LineChart;
